import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import { GetRides } from "../../Services";
import axios from "axios";

const RidesForDriver = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { driver } = location.state || {};

  // State variables for loading and ride history
  const [loading, setLoading] = useState(true);
  const [rides, setRides] = useState([]);

  // useEffect(() => {
  //   if (driver?.id) {
  //     // console.log("Driver IDIIIDIID: ", driver.id);

  //     const fetchVehicles = async () => {
  //       try {
  //         console.log("driver id: ", driver.id);
  //         const res = await axios.get(
  //           `https://binberu.idaprocharity.com/api/v1/admin/get-rides-for-driver/${driver.id}`
  //         );
  //         setRides(res.data); // Assuming API returns an array

  //         console.log("Rides list: ", res);
  //       } catch (error) {
  //         console.error("Error fetching vehicles:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchVehicles();
  //   }
  // }, [driver?.id]);

  useEffect(() => {
    const fetchDispatchers = async () => {
      setLoading(true);
      try {
        const data = await GetRides.fetchRidesByID(driver.id);
        setRides(Array.isArray(data) ? data : []);

        // console.log("Vehicles", data);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDispatchers();
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="">
            Ride Information of{" "}
            <span className="text-primary">
              {driver ? driver.name : "Driver"}
            </span>
          </h2>
        </div>

        <div className="card">
          <div className="card-header">
            <button
              type="button"
              onClick={() => navigate("/drivers")}
              className="btn btn-outline-secondary ml-2"
            >
              <FaChevronLeft className="mr-1" /> Back
            </button>
          </div>
          <div className="card-body flex flex-col">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex gap-4">
                <button type="button" className="btn btn-outline-secondary">
                  CSV
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  Excel
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  PDF
                </button>
              </div>

              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                style={{ width: "300px" }}
              />
            </div>

            <div className="mt-4">
              {loading ? (
                <div className="">
                  <p>Loading ride history...</p>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : rides.length === 0 ? (
                <div className="">
                  <p>No Ride found for this driver.</p>
                </div>
              ) : (
                <table className="table table-bordered w-full">
                  <thead>
                    <tr>
                      <th>Ride ID</th>
                      <th>Passenger Phone</th>
                      <th>Driver Name</th>
                      <th>Driver Phone</th>
                      <th>Pickup Date</th>
                      <th>Drop Time</th>
                      <th>Pickup Point</th>
                      <th>Drop Point</th>
                      <th>Distance</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rides.map((ride) => (
                      <tr key={ride.id}>
                        <td>{ride.id}</td>
                        <td>{ride.user.phone_number}</td>
                        <td>{ride.driver.name}</td>
                        <td>{ride.driver.phone_number}</td>
                        <td>{ride.createdAt}</td>
                        <td>{ride.updatedAt}</td>
                        <td>{ride.currentLocationName}</td>
                        <td>{ride.destinationLocationName}</td>
                        <td>{ride.distance}</td>
                        <td>
                          <span
                            style={{
                              color: (() => {
                                switch (ride.status) {
                                  case "PENDING":
                                    return "orange";
                                  case "COMPLETE":
                                    return "green";
                                  case "CANCELED":
                                    return "red";
                                  default:
                                    return "gray";
                                }
                              })(),
                              backgroundColor: (() => {
                                switch (ride.status) {
                                  case "PENDING":
                                    return "#fff3cd"; // Light yellow for pending
                                  case "COMPLETE":
                                    return "#d4edda"; // Light green for complete
                                  case "CANCELED":
                                    return "#f8d7da"; // Light red for canceled
                                  default:
                                    return "#e9ecef"; // Light gray for unknown
                                }
                              })(),
                              padding: "2px 5px",
                              borderRadius: "4px",
                            }}
                          >
                            {ride.status.charAt(0).toUpperCase() +
                              ride.status.slice(1).toLowerCase()}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RidesForDriver;
